/* empai-pieces-bypass-2026-08-05 */
(function () {
  var SAW_KERF = 0.25;

  /** EmpAI Custom Pieces path owns fit/pricing — skip legacy Size-dropdown validation. */
  function isCustomPiecesUi() {
    return !!document.querySelector('.cut-container--pieces, [data-empai-custom-pieces]');
  }

  function withJquery(callback) {
    if (!window.jQuery) return false;
    callback(window.jQuery);
    return true;
  }

  function getSizeSelect() {
    var selects = document.querySelectorAll('.single-option-selector');
    for (var i = 0; i < selects.length; i++) {
      var name = (selects[i].getAttribute('data-name') || '').toLowerCase();
      if (name === 'size' || name === 'select size' || name.indexOf('size') !== -1) {
        return selects[i];
      }
    }
    return document.getElementById('SingleOptionSelector-0')
      || document.querySelector('.single-option-selector');
  }

  function getSheetDimensions() {
    var sizeSelect = getSizeSelect();
    if (!sizeSelect || !sizeSelect.value) return null;
    var parts = sizeSelect.value.replace(/ inch/gi, '').trim().split('x');
    if (parts.length < 2) return null;
    return { width: Number(parts[0]), length: Number(parts[1]) };
  }

  function getSheetQty() {
    var el = document.getElementById('Quantity') || document.querySelector('[name="quantity"]');
    return Number(el && el.value) || 1;
  }

  function readCutDimensions($item) {
    var width = Number($item.find('.product-form__width').val()) || 0;
    var length = Number($item.find('.product-form__length').val()) || 0;
    var fractionWidth = Number($item.find('.fraction__width').val()) || 0;
    var fractionLength = Number($item.find('.fraction__length').val()) || 0;
    return {
      width: width + fractionWidth,
      length: length + fractionLength,
      quantity: Number($item.find('.product-form__item--quantity input.cut-input, .product-form__item--quantity .product-form__quantity').val()) || 0,
    };
  }

  function formatInches(value) {
    var eighths = Math.round(Number(value) * 8);
    if (!isFinite(eighths)) return String(value);
    var whole = Math.floor(eighths / 8);
    var rem = eighths % 8;
    var map = { 1: '1/8', 2: '1/4', 3: '3/8', 4: '1/2', 5: '5/8', 6: '3/4', 7: '7/8' };
    if (rem === 0) return String(whole);
    if (whole === 0) return map[rem];
    return whole + ' ' + map[rem];
  }

  function maxPiecesAlongAxis(axisLength, pieceLength) {
    if (pieceLength <= 0 || pieceLength > axisLength) return 0;
    return Math.floor((axisLength + SAW_KERF) / (pieceLength + SAW_KERF));
  }

  function orientCutOnSheet(sheet, cutW, cutL) {
    var options = [];
    if (cutW <= sheet.width && cutL <= sheet.length) {
      options.push({
        width: cutW,
        length: cutL,
        perSheet: maxPiecesAlongAxis(sheet.width, cutW) * maxPiecesAlongAxis(sheet.length, cutL),
      });
    }
    if (cutL <= sheet.width && cutW <= sheet.length) {
      options.push({
        width: cutL,
        length: cutW,
        perSheet: maxPiecesAlongAxis(sheet.width, cutL) * maxPiecesAlongAxis(sheet.length, cutW),
      });
    }
    if (!options.length) return null;
    options.sort(function (a, b) { return b.perSheet - a.perSheet; });
    return options[0];
  }

  function maxPieceLengthForCount(axisLength, count) {
    if (count <= 0) return 0;
    return (axisLength - (count - 1) * SAW_KERF) / count;
  }

  function pieceOrientations(sheet, cutW, cutL) {
    var options = [];
    if (cutW <= sheet.width + 0.001 && cutL <= sheet.length + 0.001) {
      options.push([cutW, cutL]);
    }
    if (
      Math.abs(cutW - cutL) > 0.001 &&
      cutL <= sheet.width + 0.001 &&
      cutW <= sheet.length + 0.001
    ) {
      options.push([cutL, cutW]);
    }
    options.sort(function (a, b) {
      return b[1] - a[1] || b[0] - a[0];
    });
    return options;
  }

  function placePieceOnSheetBin(bin, sheet, pw, pl, kerf) {
    for (var i = 0; i < bin.shelves.length; i++) {
      var shelf = bin.shelves[i];
      if (pl <= shelf.h + 0.001) {
        var gap = shelf.n > 0 ? kerf : 0;
        if (shelf.x + gap + pw <= sheet.width + 0.001) {
          shelf.x += gap + pw;
          shelf.n += 1;
          return true;
        }
      }
    }
    var y = 0;
    if (bin.shelves.length) {
      var last = bin.shelves[bin.shelves.length - 1];
      y = last.y + last.h + kerf;
    }
    if (pw <= sheet.width + 0.001 && y + pl <= sheet.length + 0.001) {
      bin.shelves.push({ y: y, h: pl, x: pw, n: 1 });
      return true;
    }
    return false;
  }

  function packPiecesShelf(sheet, pieces, sheetQty) {
    if (sheetQty <= 0) return false;
    if (!pieces.length) return true;
    var totalArea = 0;
    for (var i = 0; i < pieces.length; i++) {
      if (!orientCutOnSheet(sheet, pieces[i].width, pieces[i].length)) return false;
      totalArea += pieces[i].width * pieces[i].length;
    }
    if (totalArea > sheet.width * sheet.length * sheetQty + 0.001) return false;

    var sorted = pieces.slice().sort(function (a, b) {
      return b.width * b.length - a.width * a.length;
    });
    var bins = [];
    for (var s = 0; s < sheetQty; s++) bins.push({ shelves: [] });

    for (var p = 0; p < sorted.length; p++) {
      var orients = pieceOrientations(sheet, sorted[p].width, sorted[p].length);
      if (!orients.length) return false;
      var placed = false;
      for (var b = 0; b < bins.length && !placed; b++) {
        for (var o = 0; o < orients.length; o++) {
          var snapshot = bins[b].shelves.map(function (shelf) {
            return { y: shelf.y, h: shelf.h, x: shelf.x, n: shelf.n };
          });
          if (placePieceOnSheetBin(bins[b], sheet, orients[o][0], orients[o][1], SAW_KERF)) {
            placed = true;
            break;
          }
          bins[b].shelves = snapshot;
        }
      }
      if (!placed) return false;
    }
    return true;
  }

  function packCutsAcrossSheets(sheet, demands, sheetQty) {
    var pieces = [];
    for (var i = 0; i < demands.length; i++) {
      var demand = demands[i];
      if (!orientCutOnSheet(sheet, demand.width, demand.length)) return false;
      for (var q = 0; q < demand.quantity; q++) {
        pieces.push({ width: demand.width, length: demand.length });
      }
    }
    if (!pieces.length) return true;

    // Full-width strips: pack along sheet length with kerf (exact prior behavior).
    var allFullWidth = pieces.every(function (cut) {
      var oriented = orientCutOnSheet(sheet, cut.width, cut.length);
      return oriented && Math.abs(oriented.width - sheet.width) < 0.001;
    });
    if (allFullWidth) {
      var lengths = pieces.map(function (cut) {
        return orientCutOnSheet(sheet, cut.width, cut.length).length;
      });
      lengths.sort(function (a, b) { return b - a; });
      var bins = [];
      for (var s = 0; s < sheetQty; s++) bins.push({ used: 0, count: 0 });
      for (var p = 0; p < lengths.length; p++) {
        var placed = false;
        for (var b = 0; b < bins.length; b++) {
          var kerf = bins[b].count > 0 ? SAW_KERF : 0;
          if (bins[b].used + kerf + lengths[p] <= sheet.length + 0.001) {
            bins[b].used += kerf + lengths[p];
            bins[b].count++;
            placed = true;
            break;
          }
        }
        if (!placed) return false;
      }
      return true;
    }

    // Mixed sizes: require total area + real multi-piece nest (never per-type-only).
    return packPiecesShelf(sheet, pieces, sheetQty);
  }

  function getAllCutDemands($, excludeItem) {
    var demands = [];
    $('.cut-item').each(function () {
      var $item = $(this);
      if (excludeItem && $item.is(excludeItem)) return;
      var dims = readCutDimensions($item);
      if (dims.quantity <= 0 || dims.width <= 0 || dims.length <= 0) return;
      demands.push(dims);
    });
    return demands;
  }

  function clearCutMessages($) {
    $('.cut-message').removeClass('active');
  }

  function ensureKerfMessageElement($) {
    if (!$('.cut-kerf-error').length) {
      $('.cut-size-error').after(
        '<p class="cut-kerf-error cut-message">Cuts do not fit on the sheet when accounting for the 1/4" saw blade.</p>'
      );
    }
  }

  function showCutMessage($, className) {
    if (className === '.cut-kerf-error') ensureKerfMessageElement($);
    clearCutMessages($);
    $(className).addClass('active');
  }

  function resetCutData($item) {
    $item.find('.cut-data').attr('name', 'properties[Custom Cut: 0 X 0]').val(0);
  }

  function commitCutData($item, dims) {
    $item.find('.cut-data')
      .attr('name', 'properties[Custom Cut: ' + dims.width + ' X ' + dims.length + ']')
      .val(dims.quantity);
  }

  function updateKerfErrorMessage($, sheet, dims, oriented, sheetQty) {
    var maxPerSheet = oriented.perSheet;
    var maxTotal = maxPerSheet * sheetQty;
    var maxLen = maxPieceLengthForCount(sheet.length, Math.min(dims.quantity, maxPerSheet));
    var msg = 'A 1/4" saw blade is used between cuts. ';
    if (dims.quantity > maxTotal) {
      msg += 'On a ' + sheet.width + '" × ' + sheet.length + '" sheet you can fit at most ' + maxPerSheet + ' piece(s) of ' + oriented.width + '" × ' + formatInches(oriented.length) + '" per sheet';
      if (sheetQty > 1) msg += ' (' + maxTotal + ' total with ' + sheetQty + ' sheets)';
      msg += '.';
      if (Math.abs(dims.length - 12) < 0.01 && Math.abs(sheet.length - 48) < 0.01 && dims.quantity >= 4) {
        msg += ' Example: four 12" cuts on a 48" length fit only 3 at full size — the fourth must be shorter than 12".';
      }
    } else {
      msg += 'For ' + dims.quantity + ' piece(s) on a ' + sheet.width + '" × ' + sheet.length + '" sheet, the max length is ' + formatInches(maxLen) + '" (not ' + formatInches(dims.length) + '").';
      if (dims.quantity === 2 && Math.abs(dims.length - 36) < 0.01 && Math.abs(sheet.length - 72) < 0.01) {
        msg += ' Example: two 12×36 cuts do not fit — use 12×35-7/8 instead.';
      }
    }
    $('.cut-kerf-error').text(msg);
  }

  function updateSizeErrorMessage($, sheet, dims) {
    $('.cut-size-error').text(
      'Cut size ' + formatInches(dims.width) + '" × ' + formatInches(dims.length) +
      '" is too large for the selected ' + sheet.width + '" × ' + sheet.length + '" sheet.'
    );
  }

  function validateCutItem($, $item, sheet, sheetQty, showErrors) {
    var dims = readCutDimensions($item);

    if (dims.quantity <= 0 || dims.width <= 0 || dims.length <= 0) {
      resetCutData($item);
      return { ok: true, reason: 'empty' };
    }

    var oriented = orientCutOnSheet(sheet, dims.width, dims.length);
    if (!oriented) {
      resetCutData($item);
      if (showErrors) {
        updateSizeErrorMessage($, sheet, dims);
        showCutMessage($, '.cut-size-error');
      }
      return { ok: false, reason: 'size' };
    }

    if (dims.quantity > oriented.perSheet * sheetQty) {
      resetCutData($item);
      if (showErrors) {
        updateKerfErrorMessage($, sheet, dims, oriented, sheetQty);
        showCutMessage($, '.cut-kerf-error');
      }
      return { ok: false, reason: 'kerf' };
    }

    var demands = getAllCutDemands($, null);
    if (!packCutsAcrossSheets(sheet, demands, sheetQty)) {
      resetCutData($item);
      if (showErrors) {
        updateKerfErrorMessage($, sheet, dims, oriented, sheetQty);
        showCutMessage($, '.cut-kerf-error');
      }
      return { ok: false, reason: 'kerf' };
    }

    commitCutData($item, dims);
    return { ok: true, dims: dims };
  }

  function validateAndCommitCutItem($, $item, showErrors) {
    if (isCustomPiecesUi()) return true;
    var sheet = getSheetDimensions();
    if (!sheet) {
      resetCutData($item);
      if (showErrors) {
        showCutMessage($, '.cut-size-error');
        $('.cut-size-error').text('Could not read the selected sheet size. Please choose a size and try again.');
      }
      return false;
    }

    var result = validateCutItem($, $item, sheet, getSheetQty(), showErrors);
    if (result.ok) clearCutMessages($);
    if (typeof window.calcPriceWithCutItems === 'function') window.calcPriceWithCutItems();
    return result.ok;
  }

  function validateAllCuts($, showErrors) {
    if (isCustomPiecesUi()) return true;
    var sheet = getSheetDimensions();
    if (!sheet) {
      if (showErrors && $('.cut-item').length) {
        showCutMessage($, '.cut-size-error');
        $('.cut-size-error').text('Could not read the selected sheet size. Please choose a size and try again.');
      }
      return false;
    }
    if (!$('.cut-item').length) return true;

    var sheetQty = getSheetQty();
    var demands = getAllCutDemands($, null);
    if (!demands.length) return true;

    if (!packCutsAcrossSheets(sheet, demands, sheetQty)) {
      if (showErrors) {
        var failedSize = null;
        for (var d = 0; d < demands.length; d++) {
          if (!orientCutOnSheet(sheet, demands[d].width, demands[d].length)) {
            failedSize = demands[d];
            break;
          }
        }
        if (failedSize) {
          updateSizeErrorMessage($, sheet, failedSize);
          showCutMessage($, '.cut-size-error');
        } else {
          var sample = demands[0];
          var oriented = orientCutOnSheet(sheet, sample.width, sample.length);
          if (oriented) updateKerfErrorMessage($, sheet, sample, oriented, sheetQty);
          showCutMessage($, '.cut-kerf-error');
        }
      }
      $('.cut-item').each(function () { resetCutData($(this)); });
      if (typeof window.calcPriceWithCutItems === 'function') window.calcPriceWithCutItems();
      return false;
    }

    var ok = true;
    var reason = null;
    $('.cut-item').each(function () {
      var result = validateCutItem($, $(this), sheet, sheetQty, false);
      if (!result.ok) {
        ok = false;
        reason = result.reason;
        return false;
      }
    });

    if (!ok) {
      if (showErrors) {
        if (reason === 'kerf') showCutMessage($, '.cut-kerf-error');
        else showCutMessage($, reason === 'size' ? '.cut-size-error' : '.cut-square-error');
      }
      if (typeof window.calcPriceWithCutItems === 'function') window.calcPriceWithCutItems();
      return false;
    }

    clearCutMessages($);
    if (typeof window.calcPriceWithCutItems === 'function') window.calcPriceWithCutItems();
    return true;
  }

  function getCutPricingSummary($) {
    if (isCustomPiecesUi()) return { count: 0, fee: 0 };
    var sheet = getSheetDimensions();
    if (!sheet) return { count: 0, fee: 0 };
    var sheetQty = getSheetQty();
    var demands = getAllCutDemands($, null);
    if (!demands.length || !packCutsAcrossSheets(sheet, demands, sheetQty)) {
      return { count: 0, fee: 0 };
    }
    var count = 0;
    for (var i = 0; i < demands.length; i++) count += demands[i].quantity;
    var cutFee = Number($('#cut-to-size-price').data('price')) / 100 || 0;
    return { count: count, fee: count * cutFee };
  }

  function patchCalcPrice($) {
    if (typeof window.calcPriceWithCutItems !== 'function' || window.calcPriceWithCutItems.__falkenPatched) return;
    window.calcPriceWithCutItems = function () {
      if (!window.jQuery) return;
      var $local = window.jQuery;
      var currentPrice = Number(
        $local('#ProductPrice-product-template').text().trim().replace(/[$,]/g, '')
      ) || 0;
      var sheetQty = getSheetQty();
      var sheetSubtotal = currentPrice * sheetQty;
      var summary = getCutPricingSummary($local);

      $local('.cut-count').text(String(summary.count));
      $local('.cut-subtotal').text('$' + summary.fee.toFixed(2));
      $local('.cut-sheet-subtotal').text('$' + sheetSubtotal.toFixed(2));
      $local('.cut-total').text('$' + (sheetSubtotal + summary.fee).toFixed(2));
    };
    window.calcPriceWithCutItems.__falkenPatched = true;
    window.calcPriceWithCutItems();
  }

  function bindCutFixes() {
    if (!withJquery(function ($) {
      window.falkenValidateAllCuts = function (showErrors) {
        return validateAllCuts($, showErrors);
      };
      window.falkenValidateCutItem = function ($item, showErrors) {
        return validateAndCommitCutItem($, $item, showErrors);
      };
      window.falkenGetCutPricingSummary = function () {
        return getCutPricingSummary($);
      };
      window.falkenSyncCutsBeforeAdd = function () {
        if (!$('.cut-item').length) return true;
        return validateAllCuts($, true);
      };

      patchCalcPrice($);
      ensureKerfMessageElement($);

      $(document).off('change keyup input', '.cut-input');
      $(document).off('click', '.add-cut_item');

      $(document).on('input.falkenCustomCutFix change.falkenCustomCutFix keyup.falkenCustomCutFix', '.cut-input', function () {
        validateAndCommitCutItem($, $(this).closest('.cut-item'), true);
      });

      $(document).on('click.falkenCustomCutFix', '.add-cut_item', function () {
        var $item = $(this).closest('.cut-item');
        if (!validateAndCommitCutItem($, $item, true)) return;
        $('.cut-container').removeClass('active');
        $('.cut-item').removeClass('active');
      });

      $(document).on('change.falkenCustomCutFix keyup.falkenCustomCutFix input.falkenCustomCutFix', '#Quantity, [name="quantity"]', function () {
        validateAllCuts($, true);
      });

      $(document).on('click.falkenCustomCutFix', '.js-qty__adjust', function () {
        var input = $(this).siblings('.js-qty__input')[0] || $(this).closest('.js-qty').find('.js-qty__input')[0];
        if (input && (input.id === 'Quantity' || input.name === 'quantity')) {
          setTimeout(function () { validateAllCuts($, true); }, 0);
        }
      });

      $(document).on('change.falkenCustomCutFix', '.single-option-selector', function () {
        setTimeout(function () { validateAllCuts($, true); }, 0);
      });

      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form || !form.getAttribute('action') || form.getAttribute('action').indexOf('/cart/add') === -1) return;
        if (!$('.cut-item').length) return;
        if (!validateAllCuts($, true)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    })) {
      return;
    }
  }

  function schedule() {
    bindCutFixes();
    setTimeout(bindCutFixes, 100);
    setTimeout(bindCutFixes, 300);
    setTimeout(bindCutFixes, 1500);
    setTimeout(bindCutFixes, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', bindCutFixes);
})();
